import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import FormBuilder from '../FormBuilder/FormBuilder';

// AD-2689: the template is shown as the form will look, so the user can check it before choosing it.
// eslint-disable-next-line react/prop-types
const CreateFormTemplatePreviewDialog = ({open, template, onClose, onUseTemplate, colour = '#186BBE'}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="md"
        data-testid="template-preview-dialog"
    >
        <DialogTitle sx={{py: 1.5}}>
            {/* eslint-disable-next-line react/prop-types */}
            {template?.name || template?.formName || ''}
        </DialogTitle>

        <DialogContent dividers sx={{p: 0}}>
            {template
                ? (
                    <Box sx={{pointerEvents: 'none'}}>
                        {/* Shown as the form will look: preview mode, so there are no edit icons and no
                            'Preview' link of its own (walkthrough finding 6, 15 October 2026). */}
                        <FormBuilder
                            /* eslint-disable-next-line react/prop-types */
                            schema={template.schema ?? []}
                            readOnly
                            data={{}}
                            previewMode
                            onPreviewModeChange={() => {}}
                        />
                    </Box>
                )
                : (
                    <Typography sx={{p: 2}}>Loading...</Typography>
                )}
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose}>Close</Button>
            <Button
                variant="outlined"
                onClick={() => onUseTemplate(template)}
                disabled={!template}
                data-testid="template-preview-use"
                sx={{color: colour, borderColor: colour, '&:hover': {borderColor: colour, backgroundColor: '#fff'}}}
            >
                Use this template
            </Button>
        </DialogActions>
    </Dialog>
);

export default CreateFormTemplatePreviewDialog;
